<template>
  <div class="weekplan">
      <div class="week_note" v-if="weeknote !== undefined && weeknote.length && !isLoading">
        <div v-html="weekNoteWithLineBreaks"></div>
      </div>
      <div v-else>
      <span v-if="!anyNotes && !isLoading">
      {{ $t('vue.public.no_notes') }}
      </span>
      </div>
      <ul>
        <template v-for="day in eventsWithNotes">
          <li class="day_change" v-if="day.lessons.length !== 0">
            <div class="day_change_header">
              <h3>{{ $filters.capitalize($filters.dateNoYear(day.date)) }}</h3>
            </div>
            <template v-for="event in day.lessons">
              <d-week-plan-lesson
                :event="event"
                :date="date">
              </d-week-plan-lesson>
            </template>
          </li>
        </template>
      </ul>
  </div>
</template>

<script>
  import dWeekPlanLesson from './WeekPlanLesson'

  import moment from 'moment'  // eslint-disable-line no-unused-vars
  import eventbus from '../../../../eventbus'
  export default{
    components: {
      dWeekPlanLesson
    },
    props: {
      events: {},
      calId: {},
      date: {
        default: moment().utc()
      },
      weeknote: {
        default: ''
      }
    },
    data () {
      return {
        weekNote: ''
      }
    },
    computed: {
      weekNoteWithLineBreaks () {
        return this.weeknote.replace(/(?:\r\n|\r|\n)/g, '<br/>')
      },
      isLoading () {
        return eventbus.loadingEvents
      },
      eventsWithNotes () {
        let allDates = []
        for (let i = 1; i < 8; i++) {
          let date = moment(this.date).isoWeekday(i).locale('en').format('YYYY-MM-DD')
          let arr = this.filterLesson(i).concat()
          allDates.push({date, lessons: arr})
        }
        return allDates
      },
      anyNotes () {
        return this.events.find(event => {
          if (event.has_notes) {
            return event.has_notes
          }
        })
      }
    },
    methods: {
      filterLesson (dayNum) {
        return this.events.filter(lesson => {
          let lessonDate = moment(lesson.start).locale('en').format('YYYY-MM-DD')
          let day = moment(this.date).isoWeekday(dayNum).locale('en').format('YYYY-MM-DD')
          return moment(lessonDate).isSame(day) && lesson.has_notes
        })
      }
    }
  }
</script>

<style scoped>
  #weekplan {
    margin-top: 40px;
  }

  #header {
    font-size: 16px;
    padding: 10px 20px;
  }

  .day_change {
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .day_change_header {
    padding: 5px 0 5px 0;
    margin-bottom: 5px;
  }

  .day_change > .grid {
    padding: 5px 20px;
  }

  .week_note {
    font-size: 13px;
    background: #f6f7f8;
    border-left: 3px solid #f6f7f8;
    border-radius: 3px;
    overflow: hidden;
    padding: 10px 20px;
    margin-bottom: 10px;
  }

  @media print {
    .weekplan.hide {
      display: none !important;
    }
  }

</style>



// WEBPACK FOOTER //
// WeekPlan.vue?7da2225f